<template>
    <div class="contentTrack-container">
        <headline :params="headLines" />
        <div v-if="true" class="content-container">
            <div class="title">填写您需要搜索的文稿信息</div>
            <div class="content">
                <ul>
                    <li>
                        <div class="title on">标题：</div>
                        <div class="input">
                            <input v-model="title" placeholder="请填写文章标题" type="text">
                        </div>
                    </li>
                    <li>
                        <div class="title on">发布时间：</div>
                        <div class="input">
                            <el-date-picker
                                v-model="date"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                            <span style="display: block;margin: 0 5px"> - </span>
                            <el-time-picker
                                value-format="HH:mm:ss"
                                v-model="time"
                                placeholder="选择时间">
                            </el-time-picker>
                            <span class="tips">时间越精确，检索越准确</span>
                        </div>
                    </li>
                    <li class="top">
                        <div class="title on">正文：</div>
                        <div class="input">
                            <textarea v-model="content" placeholder="请输入正文"></textarea>
                        </div>
                    </li>
                    <li>
                        <div class="title">原文链接：</div>
                        <div class="input">
                            <input v-model="link" type="text" class="s">
                        </div>
                    </li>
                    <li>
                        <div class="title">发布来源：</div>
                        <div class="input">
                            <!-- <input v-model="from" type="text" class="s"> -->
                            <div class="select-box">
                                <div @click="showSelect = !showSelect">
                                    <p>{{fromName}}</p>
                                    <i></i>
                                </div>
                                <ul v-click-outside="closeSelectList" v-if="showSelect">
                                    <li v-for="item in selectList" :key="item.key" @click="from = item.key;fromName = item.val;showSelect = false;" :class="{on: from == item.key}">{{item.val}}</li>
                                </ul>
                            </div>
                            <span class="tips">如网站、微信、微博等</span>
                        </div>
                    </li>
                    <li>
                        <div class="title">发布媒介：</div>
                        <div class="input">
                            <input v-model="media" type="text" class="s">
                            <span class="tips">如看看新闻、新华社等</span>
                        </div>
                    </li>
                    <li>
                        <div class="title">作者：</div>
                        <div class="input">
                            <input v-model="auth" type="text" class="s">
                        </div>
                    </li>
                </ul>
                <div @click="search" :class="{btn: true, un: !isCheck}">开始检索</div>
            </div>
        </div>
        <div v-if="showConfirm" class="loading-container">
            <div class="mask">
                <div class="content">
                    <img src="../../assets/img/analysis/success.png" alt="">
                    <p class="title">提交成功</p>
                    <div>
                        请注意
                        <span>消息中心</span>
                        或在
                        <span>历史查询</span>
                        中查看结果数据
                    </div>
                    <p @click="close" class="btn"></p>
                </div>
            </div>
        </div>
        <div v-if="false" class="list-container">
            <p class="tips">共<span>12</span>条数据与文稿匹配</p>
            <div class="list">
                <ul>
                    <li>
                        <div>
                            <div class="left">
                                <div class="title">治理幼儿园“小学化”孩子该学还是该玩？</div>
                                <div class="content">3月16日，教育部部长陈宝生在答记者问中，再次明确提出：要综合治理幼儿园小学化倾向，幼儿园的基本教学模式是游戏模式，不是教学模式。综合治理小学化倾向，这个问题也是很大的事情。我们现在，有一些幼儿园老师是从小学老师转过去的，没有学过幼儿托育。</div>
                                <div class="info">
                                    <span>论坛</span>
                                    <span>百度贴吧</span>
                                    <span>
                                        <i></i>
                                        2019-03-23  05:30:22
                                    </span>
                                </div>
                            </div>
                            <div class="right">
                                <img src="" alt="">
                                <img class="playBtn" src="../../assets/img/index/play.svg" alt="">
                            </div>
                        </div>
                    </li>
                </ul>
                <pages style="margin-bottom: 50px;" :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
            </div>
        </div>
    </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import { apis } from '@common/config'
import headline from "@components/headline";
import DatePicker from 'vue2-datepicker'
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        headline,DatePicker,pages
    },
    watch: {
        title() {
            this.checkInput()
        },
        content() {
            this.checkInput()
        },
        date() {
            this.checkInput()
        },
        time(e) {
            if(e == null){
                this.time = ''
            }
        }
    },
    data() {
        return {
            showSelect: false,
            fromName: '',
            id: null,
            showDetail: false,
            showConfirm: false,
            title: '',
            content: '',
            link: '',
            from: '',
            media: '',
            auth: '',
            page: {
                page_count: 0,
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            date: '',
            time: '',
            isCheck: false,
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            selectList: []
        }
    },
    methods: {
        closeSelectList() {
            this.showSelect = false
        },
        close() {
            window.close()
        },
        checkInput() {
            console.log(this.title,this.date,this.content)
            if(this.title.length > 0 && this.date.length > 0 && this.content.length >0){
                this.isCheck = true
            }else{
                this.isCheck = false
            }
        },
        search() {
            let info = {
                title: this.title,
                date: this.date,
                time: this.time,
                content: this.content,
                url: this.link,
                type: this.from,
                client_name: this.media,
                author: this.auth
            }

            common.myFetch(apis.track,info).then(res => {
                console.log(res)
                if(res) {
                    this.showConfirm = true
                }
            })
        },
        getTrackSelect() {
            common.myFetch(apis.trackSelect).then(res => {
                if(res) {
                    this.selectList = res.list
                    console.log(res)
                }
            })
        }
    },
    created() {
        this.headLines.title = '文稿追踪'
        this.getTrackSelect()
    }
}
</script>

<style scoped lang="less">
    .contentTrack-container {
        .content-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            &>.title {
                margin: 20px 0;
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: bold;
            }

            .content {
                width: 874px;
                height: 652px;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                padding:  50px 94px;
                box-sizing: border-box;

                ul {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 19px;
                        width: 100%;

                        &.top {
                            align-items: flex-start;

                            .title {
                                margin-top: 10px;
                            }
                        }

                        .title {
                            position: relative;
                            min-width: 84px;
                            font-size: 14px;
                            line-height: 20px;
                            color: #829191;
                            font-weight: bold;
                            margin-right: 30px;

                            &.on {
                                &::after {
                                    position: absolute;
                                    top: 0;
                                    left: -14px;
                                    display: block;
                                    content: '*';
                                    font-size: 16px;
                                    color: #FF555A;
                                }
                            }
                        }

                        .input {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: calc(100% - 114px);

                            .el-date-editor.el-input {
                                width: 200px;
                                min-width: 100px !important;
                            }

                            .mx-input {
                                min-width: 100px !important;
                            }

                            input {
                                width: 100%;
                                height: 40px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                padding: 0 20px;
                                box-sizing: border-box;
                            }

                            .tips {
                                display: block;
                                font-size: 13px;
                                line-height: 18px;
                                color: #829191;
                                margin-left: 10px;
                            }

                            textarea {
                                width: 100%;
                                height: 158px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                resize: none;
                                padding: 10px 20px;
                                box-sizing: border-box;
                            }

                            .s {
                                width: 400px;
                                height: 40px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                            }

                            .select-box {
                                position: relative;
                                width: 400px;
                                height: 40px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                border: none;

                                &>div {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 100%;
                                    height: 100%;
                                    box-sizing: border-box;

                                    p {
                                        font-size: 14px;
                                    }

                                    i {
                                        display: block;
                                        width: 12px;
                                        height: 8px;
                                        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABGdBTUEAALGPC/xhBQAAAHtJREFUCB1j3HXkyFaG///5Obi5A+2MjF4zIIFD586J/vj6dT0DI+NHJpCi/wwM1t+/fdsPkoCpA7FBYiA5kBpGmACQow3UeZWTi8sRpBikCFmMESSIrhgkhqwI5CSwQpA4imKQANR0mLvhCkFyO48eFWP8928diI3uOQBKTlEqfGTG1AAAAABJRU5ErkJggg==) no-repeat;
                                        background-size: 100% 100%;
                                        background-position: center center;
                                        
                                    }

                                }

                                ul {
                                    position: absolute;
                                    top: 50px;
                                    left: 0;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    // height: inherit;
                                    background: #FFF;

                                    li {
                                        position: relative;
                                        width: 100%;
                                        height: 40px;
                                        line-height: 40px;
                                        padding: 0 20px;
                                        box-sizing: border-box;
                                        user-select: none;
                                        cursor: pointer;
                                        margin: 0;
                                        font-size: 14px;

                                        &:hover {
                                            background: rgba(65, 180, 140, 0.15);
                                        }

                                        &.on {
                                            &::before {
                                                content: "";
                                                display: block;
                                                width: 14px;
                                                height: 11px;
                                                background: url('../../assets/img/common/select.svg') no-repeat;
                                                background-position: right center;
                                                position: absolute;
                                                right: 20px;
                                                top: 50%;
                                                margin-top: -6px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .btn {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #41B48C;
                    border-radius: 25px; 
                    font-size: 14px;     
                    color: #FFFFFF;
                    margin: 11px auto 0;
                    cursor: pointer;

                    &.un {
                        color: rgba(255,255,255,0.5);
                    }
                }
            }
        }

        .loading-container {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .mask {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.7);

                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -200px;
                    margin-top: -145px;
                    width: 400px;
                    height: 290px;
                    background: #F9F9F9;
                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                    border-radius: 4px;

                    img {
                        width: 50px;
                        height: 50px;
                        background: url('../../assets/img/analysis/success.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .title {
                        font-size: 20px;
                        line-height: 28px;
                        color: #050F0F;
                        font-weight: bold;
                        margin: 30px auto 12px;
                    }

                    div {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        font-size: 14px;
                        line-height: 20px;
                        color: #829191;
                        margin-bottom: 30px;

                        span {
                            color: #41B48C;
                        }
                    }

                    .btn {
                        width: 120px;
                        height: 40px;
                        background: url('../../assets/img/analysis/confirm.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }
        }

        .list-container {
            display: flex;
            flex-direction: column;
            width: 1064px;
            margin: 0 auto;

            .list {
                background: #F9F9F9;
            }

            .tips {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: bold;
                margin: 20px 0;

                span {
                    color: #41B48C;
                }
            }

            ul {
                display: flex;
                flex-direction: column;
                width: 100%;

                li {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding: 0px 30px;
                    box-sizing: border-box;
                    background: #F9F9F9;
                    

                    &>div {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        padding: 28px 0;
                        border-bottom: 1px solid #F0F0F0;
                        box-sizing: border-box;
                    }

                    &:hover {    
                        background: rgba(185, 195, 195, 0.15);

                        .left {
                            .title {
                                color: #41B48C;
                            }
                        }
                    }

                    .left {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        flex: 1;

                        .title {
                            font-size: 18px;
                            line-height: 25px;
                            color: #050F0F;        
                            font-weight: bold;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            margin-bottom: 20px;
                        }

                        .content {
                            font-size: 14px;
                            line-height: 24px;
                            color: #829191;
                            margin-bottom: 22px;
                        }

                        .info {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            span {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-size: 13px;
                                line-height: 18px;
                                color: #B9C3C3;
                                margin-right: 40px;

                                i {
                                    display: block;
                                    width: 23px;
                                    height: 23px;
                                    background: url('../../assets/img/material/clockIcon.svg') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }

                    .right {
                        position: relative;
                        width: 240px;
                        height: 135px;
                        border-radius: 4px;
                        margin-left: 100px;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .playBtn {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            margin: auto;
                            width: 40px;
                            height: auto;
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="less">
    .contentTrack-container .mx-input {
        min-width: 100px !important;
    }

    .el-date-table td.current:not(.disabled) span {
        background: #41B48C !important;
    }

    .el-date-table td.today span {
        color: #41B48C !important;
    }

    .el-date-table td.today span {
        color: #41B48C !important;
    }

    .el-date-table td.available:hover {
        color: #41B48C !important;
    }

    .el-date-picker__header-label:hover {
        color: #41B48C !important;
    }

    .el-picker-panel__icon-btn:hover {
        color: #41B48C !important;
    }

    .el-time-panel__btn.confirm {
        color: #41B48C !important;
    }

    // .el-input__inner {
    //     background: rgba(185, 195, 195, 0.2) !important;
    // }
</style>